import { IConfigFunctionArgs } from 'Components/Equipment/Core';
import * as oPath from '../../../../Lib/Object/Path/Immutable';
import { UNITS_METRIC } from '../SieveSetHelper';

// Dimensions are also configured in equipmentTypes. Make sure changes are also made there.
// TODO: Revise how equipment config is used so these aren't configured separately.
const getConfig = (prefix: string) => ({
  [`${prefix}.Dimensions.Width`]: (configArgs: IConfigFunctionArgs) => {
    const units = oPath.get(configArgs.equipment, `${prefix}.Units`);
    return {
      format: units === UNITS_METRIC ? { nearest: 1 } : { nearest: 0.1 },
      uom: units === UNITS_METRIC ? 'mm' : 'in',
    };
  },
  [`${prefix}.Dimensions.Length`]: (configArgs: IConfigFunctionArgs) => {
    const units = oPath.get(configArgs.equipment, `${prefix}.Units`);
    return {
      format: units === UNITS_METRIC ? { nearest: 1 } : { nearest: 0.1 },
      uom: units === UNITS_METRIC ? 'mm' : 'in',
    };
  },
  [`${prefix}.Dimensions.Diameter`]: (configArgs: IConfigFunctionArgs) => {
    const units = oPath.get(configArgs.equipment, `${prefix}.Units`);
    return {
      format: units === UNITS_METRIC ? { nearest: 1 } : { nearest: 0.1 },
      uom: units === UNITS_METRIC ? 'mm' : 'in',
    };
  },
});

export { getConfig };

export default {
  30008: getConfig('data'),
};
